import React, { Component } from 'react'
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom'
import ApiAssets from '../../utils/api.assets'
import "./home.scss"
import Loading from "../../components/Loading"

class QuantityClassetsModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      classets: [],
      loading: false
    }
  }

  getClassets = (idKey) => {
    if (idKey) {
      ApiAssets.getMy(idKey).then(response => {
        if (response.data && response.data.my_classets) {
          const classets = response.data.my_classets;
          this.setState(...this.state, { classets: classets, loading: false })
        }
      });
    }
  }

  componentWillReceiveProps(props) {
    if (props.idKey) {
      this.setState(...this.state, { classets: [], loading: true });
      this.getClassets(props.idKey);
    }
  }

  render() {
    return (
      <Modal className="modal-md modal-classets-quantity" isOpen={this.props.isOpen} toggle={this.props.toggleModalClassets}>
        <ModalHeader className="modal-classets-quantity-header">
          <h5 className="section-title">Classets</h5>
        </ModalHeader>
        <ModalBody className="modal-classets-quantity-body">
          <div className="container">
            <div className="row jusfity-content-center">
              <div className="col-md-12">
                <table className="table">
                  <tbody>
                    {this.state.classets.map((item, index) => {
                      const path_url = `/assets/?assetline=${item.assetline}`;
                      return (
                        <tr>
                          <td>
                            <Link to={path_url}>
                              <img className="classet-image" src={item.info.image} />
                            </Link>
                          </td>
                          <td className="align-middle">
                            <Link to={path_url}>{item.info.name}</Link>
                          </td>
                          {/* <td>
                            <Link to={path_url}>
                              <button className="btn btn-outline-success">
                                BUY
                              </button>
                            </Link>
                          </td> */}
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <Loading active={this.state.loading}></Loading>
        </ModalBody>
        <ModalFooter className="modal-classets-quantity-footer">
          <button className="btn btn-outline-light float-right" type="button" onClick={this.props.toggleModalClassets}>Back</button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default QuantityClassetsModal;


// WEBPACK FOOTER //
// ./src/containers/HomePage/quantity-classets-modal.js